import { BiMinus, BiPlus } from 'react-icons/bi'
import { SquircleAdapter } from '@/components/SquircleAdapter'
import { PriceBy, PriceByProps } from '../PriceBy'
import './styles.scss'

type CountableOptionProps = {
  value: string
  icon?: React.ReactNode
  selected?: boolean
  onClick?: () => void
  label?: string
  priceBy?: PriceByProps
  description?: string
  count?: number
  onCountSubtract?: () => void
  onCountAdd?: () => void
}

export function CountableOption({
  value,
  icon,
  selected,
  onClick,
  label,
  priceBy,
  count,
  onCountSubtract,
  onCountAdd,
}: CountableOptionProps) {
  const quantity = count || 0

  return (
    <div
      className="countable-option"
      onClick={onClick}
      data-selected={selected}
      role="group"
      aria-label={value}
    >
      <SquircleAdapter cornerRadius={12} className="countable-option__wrapper">
        <div className="countable-option__wrapper__count">
          <button
            type="button"
            onClick={onCountSubtract}
            disabled={quantity === 0}
            aria-label={`Remover uma unidade de ${value}`}
          >
            <BiMinus aria-hidden />
          </button>

          <span
            className="countable-option__wrapper__count__number"
            aria-live="polite"
          >
            <span aria-hidden>
              {quantity} {priceBy?.by}
            </span>
            <span className="sr-only">
              {quantity === 1
                ? `1 unidade de ${value}`
                : `${quantity} unidades de ${value}`}
            </span>
          </span>

          <button
            type="button"
            onClick={onCountAdd}
            aria-label={`Adicionar uma unidade de ${value}`}
          >
            <BiPlus aria-hidden />
          </button>
        </div>

        {icon && <div className="countable-option__wrapper__icon">{icon}</div>}
        <p className="countable-option__wrapper__value">{value}</p>
        {(label || priceBy) && (
          <div className="countable-option__wrapper__separator">•</div>
        )}
        {label && (
          <div className="countable-option__wrapper__label">{label}</div>
        )}
        {priceBy && <PriceBy {...priceBy} />}
      </SquircleAdapter>
    </div>
  )
}
